import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import SubscriptionsConsole from "../components/subscriptions/SubscriptionsConsole";

const AdminSubscriptionsPage = () => {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <SubscriptionsConsole />;
};

export default AdminSubscriptionsPage;
